import InvitationsForm from 'components/auth/InvitationsForm/container';

export default InvitationsForm;
